export const careerData = [
  {
    title: "Building a Web3 Career",
    content: [
      {
        type: "heading",
        text: "Opportunities in the Decentralized Economy"
      },
      {
        type: "paragraph",
        text: "The Web3 industry offers diverse career opportunities across technology, finance, marketing, and business development. Malaysia is emerging as a significant hub for Web3 talent and innovation."
      }
    ]
  },
  {
    title: "Leading Malaysian Web3 Companies",
    content: [
      {
        type: "heading",
        text: "Local Industry Leaders"
      },
      {
        type: "list",
        items: [
          "Touch 'n Go: Digital wallet and blockchain integration",
          "Luno: Cryptocurrency exchange and trading platform",
          "MDEC: Government digital economy initiatives",
          "Fusang: Digital securities and blockchain solutions",
          "Tokenize: Asset tokenization platform"
        ]
      }
    ]
  },
  {
    title: "Web3 Job Opportunities",
    content: [
      {
        type: "heading",
        text: "Diverse Career Paths"
      },
      {
        type: "list",
        items: [
          "Blockchain Developer: Smart contracts and DApp development",
          "Web3 Product Manager: Managing decentralized products",
          "DeFi Analyst: Analyzing decentralized finance protocols",
          "NFT Artist/Creator: Digital art and collectibles",
          "Community Manager: Building Web3 communities",
          "Security Auditor: Smart contract security"
        ]
      }
    ]
  },
  {
    title: "Essential Skills",
    content: [
      {
        type: "heading",
        text: "Building Your Web3 Skillset"
      },
      {
        type: "list",
        items: [
          "Programming: Solidity, Rust, JavaScript, Python",
          "Blockchain Knowledge: Understanding different protocols",
          "DeFi Understanding: Yield farming, liquidity pools, AMMs",
          "Security Awareness: Smart contract vulnerabilities",
          "Community Building: Discord, Telegram, social media"
        ]
      }
    ]
  },
  {
    title: "Salary Information in Malaysia",
    content: [
      {
        type: "heading",
        text: "Compensation Overview"
      },
      {
        type: "list",
        items: [
          "Junior Blockchain Developer: RM 4,000 - 8,000/month",
          "Senior Blockchain Developer: RM 8,000 - 15,000/month",
          "Web3 Product Manager: RM 10,000 - 20,000/month",
          "DeFi Analyst: RM 6,000 - 12,000/month",
          "Plus potential token incentives and equity"
        ]
      }
    ]
  }
];
